import React from 'react';
import { toast } from 'react-toastify';
import { NotError } from 'components';
import { call, put, takeLatest } from 'redux-saga/effects';
import { KeyPurpose } from 'utils/constants';
import { signatureRequestService } from './signatureRequest.service';
import {
    GET_SIGNATURE_REQUEST,
    GET_SIGNATURE_REQUEST_SUCCESS,
    SIGN_SIGNATURE_REQUEST,
    SIGN_SIGNATURE_REQUEST_SUCCESS,
} from './signatureRequest.type';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';

function* getSignatureRequest(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        const res = yield call(signatureRequestService.getSignatureRequestService, action?.payload?.token);
        yield put({
            type: GET_SIGNATURE_REQUEST_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        if (err?.status === 401) return;
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* signSignatureRequest(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        const { token, file, signorId, confirmed } = action?.payload || {};

        const presignRes = yield call(signatureRequestService.presignSignatureService, token, {
            purpose: KeyPurpose.SIGNATURE,
            originalName: file.name,
            contentType: file.type,
            sizeBytes: file.size,
        });
        const { uploadUrl, requiredHeaders, file: storedFile } = presignRes.data;

        yield call(signatureRequestService.uploadSignatureService, uploadUrl, file, requiredHeaders);

        yield call(signatureRequestService.signSignatureRequestService, token, {
            file: storedFile,
            signorId,
            confirmed,
        });
        yield put({ type: SIGN_SIGNATURE_REQUEST_SUCCESS });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        if (err?.status === 401) return;
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

export const watchSignatureRequest = function* () {
    yield takeLatest(GET_SIGNATURE_REQUEST, getSignatureRequest);
    yield takeLatest(SIGN_SIGNATURE_REQUEST, signSignatureRequest);
};
